import React from "react"
import { composeSx } from "../theme/composeSx"
import { colors } from "../theme/tokens"
import { Paper, type PaperProps } from "@mui/material"

/** Canonical Client Detail / Pro content-well radius — use this everywhere. */
export const VIRA_CARD_RADIUS = "10px"

/** Canonical content padding for pane cards (Action plan, Their week, charts, …). */
export const VIRA_CARD_PADDING = { xs: 2, sm: 3 } as const

export type ViraCardProps = PaperProps & {
  /** Top accent border (e.g. Prepare empty state) */
  accentTop?: boolean
  /**
   * Apply canonical content padding (`VIRA_CARD_PADDING`).
   * Prefer this over one-off `sx={{ p: … }}` so pane cards match.
   */
  padded?: boolean
}

export function ViraCard({
  accentTop = false,
  padded = false,
  sx,
  children,
  ...rest
}: ViraCardProps) {
  return (
    <Paper
      elevation={0}
      sx={composeSx((theme) => {
        const border = theme.palette.vira?.border ?? colors.vira.border
        const ink = theme.palette.vira?.ink ?? colors.vira.ink
        const paper = theme.palette.background?.paper ?? colors.neutral.white
        return {
          backgroundColor: paper,
          border: `1px solid ${border}`,
          borderTop: accentTop ? `3px solid ${ink}` : `1px solid ${border}`,
          borderRadius: VIRA_CARD_RADIUS,
          boxShadow: "none",
          overflow: "hidden",
          ...(padded ? { p: VIRA_CARD_PADDING } : null),
        }
      }, sx)}
      {...rest}
    >
      {children}
    </Paper>
  )
}
